import React, { useState, useRef, useEffect } from 'react';
import {
  Card, CardBody, CardTitle, Nav, NavItem, NavLink, TabContent, TabPane,
  Row, Col, Label, Input, Form, Button, InputGroup, Badge, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import classnames from 'classnames';
import { Editor } from '@tinymce/tinymce-react';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { useNavigate } from 'react-router-dom';
import api, { FILE_BASE_URL } from '../../utils/api';
import useDuplicateCheck from '../../helpers/useDuplicateCheck';
import DuplicateWarning, { DuplicateSaveConfirm } from '../../components/DuplicateWarning';

// مكوّن إنشاء/تعديل صحفي
const CreateJournalist = (props) => {
  const { mode = 'create', journalistData = null } = props;
  const navigate = useNavigate();
  const imageInputRef = useRef(null);
  const attachmentInputRef = useRef(null);
  const profileImageRef = useRef(null);
  const videoInputRef = useRef(null); // 🆕 مرجع رفع الفيديو

  const [profileImage, setProfileImage] = useState(null);
  const [children, setChildren] = useState([]);
  const [newChild, setNewChild] = useState({ name: '', gender: '', birth_date: '' });
  const [statements, setStatements] = useState([]);
  const [newStatement, setNewStatement] = useState({ title: '', content: '' });
  const [editingStatement, setEditingStatement] = useState(null);
  const [showStatementModal, setShowStatementModal] = useState(false); // 🆕 حالة Modal التصريحات
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [newSocialAccount, setNewSocialAccount] = useState('');
  const [newYoutubeLink, setNewYoutubeLink] = useState('');
  const [institutionsList, setInstitutionsList] = useState([]);
  const [activistsList, setActivistsList] = useState([]);
  const [journalistsList, setJournalistsList] = useState([]); // 🔗 لربط صحفي بصحفي آخر
  const [images, setImages] = useState([]);
  const [videoFiles, setVideoFiles] = useState([]); // 🆕 ملفات الفيديو
  const [videoUploading, setVideoUploading] = useState({}); // 🆕 حالة رفع كل فيديو
  
  // 🆕 المؤسسات والناشطين الجدد
  const [newInstitutionName, setNewInstitutionName] = useState('');
  const [newActivistName, setNewActivistName] = useState('');
  const [selectedInstitutions, setSelectedInstitutions] = useState([]);
  const [selectedActivists, setSelectedActivists] = useState([]);
  const [newInstitutions, setNewInstitutions] = useState([]);
  const [newActivists, setNewActivists] = useState([]);
  const [selectedJournalistPeers, setSelectedJournalistPeers] = useState([]); // 🔗 صحفيون آخرون مرتبطون

  // 🆕 حالات البحث المتقدم
  const [institutionSearchTerm, setInstitutionSearchTerm] = useState('');
  const [activistSearchTerm, setActivistSearchTerm] = useState('');
  const [journalistPeerSearchTerm, setJournalistPeerSearchTerm] = useState('');
  const [filteredInstitutions, setFilteredInstitutions] = useState([]);
  const [filteredActivistsList, setFilteredActivistsList] = useState([]);
  const [filteredJournalistPeers, setFilteredJournalistPeers] = useState([]);

  // فحص الأسماء المكررة
  const { duplicateWarning, checkingDuplicate, duplicateError, handleNameBlur, handleNameChange, dismissWarning, checkBeforeSave } = useDuplicateCheck('journalist', journalistData?.id);
  const [showDuplicateConfirm, setShowDuplicateConfirm] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);

  const [formValues, setFormValues] = useState({
    full_name: '',
    profile_image: '',
    bio: '',
    gender: '',
    id_number: '',
    birth_date: '',
    marital_status: '',
    children_names: '',
    children_details: [],
    political_orientation: [],
    country: 'فلسطين', // 🆕 الدولة مع القيمة الافتراضية
    country_province: '',
    city_or_area: '',
    address_details: '',
    map_address: '',
    specialization: '',
    university_name: '',
    last_work_place: '',
    work_sector: [],
    linked_institution: '',
    linked_activists: [],
    linked_journalists: [],
    whatsapp1_code: '+970',
    whatsapp1_number: '',
    phone_fax: '',
    mobile1: '',
    oreedo_number: '',
    email: '',
    website: '',
    social_accounts: [],
    statements: [],
    videos: [],
    attachments: [],
    video_files: [], // 🆕 ملفات فيديو مرفوعة
  });

  // تحميل خريطة وتحديث الإحداثيات
  useEffect(() => {
    if (document.getElementById("map") && window.google) {
      const defaultPosition = { lat: 31.9522, lng: 35.2332 };
      const map = new window.google.maps.Map(document.getElementById("map"), {
        center: defaultPosition,
        zoom: 13,
      });
      const marker = new window.google.maps.Marker({
        position: defaultPosition,
        map,
        draggable: true,
      });
      marker.addListener("dragend", () => {
        const position = marker.getPosition();
        setFormValues(prev => ({
          ...prev,
            map_address: `${position.lat().toFixed(6)}, ${position.lng().toFixed(6)}`
        }));
      });
      map.addListener('click', (e) => {
        marker.setPosition(e.latLng);
        setFormValues(prev => ({
          ...prev,
          map_address: `${e.latLng.lat().toFixed(6)}, ${e.latLng.lng().toFixed(6)}`
        }));
      });
    }
  }, []);

  // تعبئة البيانات في وضع التعديل
  useEffect(() => {
    if (mode === 'edit' && journalistData) {
      setFormValues(prev => ({
        ...prev,
        full_name: journalistData.full_name ?? '',
        profile_image: journalistData.profile_image ?? '',
        bio: journalistData.bio ?? '',
        gender: journalistData.gender ?? '',
        id_number: journalistData.id_number ?? '',
        birth_date: journalistData.birth_date ?? '',
        marital_status: journalistData.marital_status ?? '',
        children_names: journalistData.children_names ?? '',
        children_details: Array.isArray(journalistData.children_details)
          ? journalistData.children_details : [],
        political_orientation: Array.isArray(journalistData.political_orientation)
          ? journalistData.political_orientation : [],
        country: journalistData.country ?? 'فلسطين', // 🆕 إضافة حقل الدولة
        country_province: journalistData.country_province ?? '',
        city_or_area: journalistData.city_or_area ?? '',
        address_details: journalistData.address_details ?? '',
        map_address: journalistData.map_address ?? '',
        specialization: journalistData.specialization ?? '',
        university_name: journalistData.university_name ?? '',
        last_work_place: journalistData.last_work_place ?? '',
        work_sector: Array.isArray(journalistData.work_sector)
          ? journalistData.work_sector
          : (journalistData.work_sector ? JSON.parse(journalistData.work_sector) : []),
        linked_institution: journalistData.linked_institution ?? '',
        linked_activists: Array.isArray(journalistData.linked_activists)
          ? journalistData.linked_activists
          : (journalistData.linked_activists ? JSON.parse(journalistData.linked_activists) : []),
        linked_journalists: Array.isArray(journalistData.linked_journalists)
          ? journalistData.linked_journalists
          : (journalistData.linked_journalists ? JSON.parse(journalistData.linked_journalists) : []),
        whatsapp1_code: journalistData.whatsapp1?.startsWith('+972') ? '+972' : '+970',
        whatsapp1_number: journalistData.whatsapp1 ? journalistData.whatsapp1.replace(/^\+970|\+972/, '') : '',
        phone_fax: journalistData.phone_fax ?? '',
        mobile1: journalistData.mobile1 ?? '',
        oreedo_number: journalistData.oreedo_number ?? '',
        email: journalistData.email ?? '',
        website: journalistData.website ?? '',
        social_accounts: Array.isArray(journalistData.social_accounts)
          ? journalistData.social_accounts
          : (journalistData.social_accounts ? JSON.parse(journalistData.social_accounts) : []),
        videos: Array.isArray(journalistData.videos)
          ? journalistData.videos
          : (journalistData.videos ? JSON.parse(journalistData.videos) : []),
        attachments: journalistData.attachments ? JSON.parse(journalistData.attachments) : [],
        video_files: journalistData.video_files ? JSON.parse(journalistData.video_files) : [], // 🆕
      }));

      // أطفال
      if (journalistData.children_details) {
        try {
          const parsedChildren = typeof journalistData.children_details === 'string'
            ? JSON.parse(journalistData.children_details)
            : journalistData.children_details;
          setChildren(parsedChildren || []);
        } catch {
          setChildren([]);
        }
      }

      // صور
      if (journalistData.images) {
        try {
          const parsedImages = JSON.parse(journalistData.images);
          setImages(parsedImages || []);
        } catch {
          setImages([]);
        }
      }

      // 🆕 ملفات فيديو
      if (journalistData.video_files) {
        try {
          const parsedVideoFiles = JSON.parse(journalistData.video_files);
          setVideoFiles(parsedVideoFiles || []);
        } catch {
          setVideoFiles([]);
        }
      }

      // تصريحات
      if (journalistData.statements) {
        try {
          const parsedStatements = Array.isArray(journalistData.statements)
            ? journalistData.statements
            : JSON.parse(journalistData.statements);
          setStatements(parsedStatements || []);
        } catch {
          setStatements([]);
        }
      }
    }
  }, [mode, journalistData]);

  // جلب المؤسسات والنشطاء
  useEffect(() => {
    api.get('/institutions')
      .then(res => setInstitutionsList(Array.isArray(res.data) ? res.data : res.data.data || []))
      .catch(() => setInstitutionsList([]));
    api.get('/activists')
      .then(res => setActivistsList(Array.isArray(res.data) ? res.data : res.data.data || []))
      .catch(() => setActivistsList([]));
    // 🔗 جلب كل الصحفيين لربط صحفي بصحفي آخر
    api.get('/journalists')
      .then(res => setJournalistsList(Array.isArray(res.data) ? res.data : res.data.data || []))
      .catch(() => setJournalistsList([]));
  }, []);

  // 🆕 useEffect للبحث المتقدم في المؤسسات
  useEffect(() => {
    if (institutionSearchTerm.trim() === '') {
      setFilteredInstitutions(institutionsList);
    } else {
      const filtered = institutionsList.filter(institution =>
        institution.title.toLowerCase().includes(institutionSearchTerm.toLowerCase())
      );
      setFilteredInstitutions(filtered);
    }
  }, [institutionSearchTerm, institutionsList]);

  // 🆕 useEffect للبحث المتقدم في الناشطين
  useEffect(() => {
    if (activistSearchTerm.trim() === '') {
      setFilteredActivistsList(activistsList);
    } else {
      const filtered = activistsList.filter(activist =>
        activist.full_name.toLowerCase().includes(activistSearchTerm.toLowerCase())
      );
      setFilteredActivistsList(filtered);
    }
  }, [activistSearchTerm, activistsList]);

  // 🆕 useEffect لتحديث القوائم المفلترة عند تحميل البيانات
  useEffect(() => {
    setFilteredInstitutions(institutionsList);
  }, [institutionsList]);

  useEffect(() => {
    setFilteredActivistsList(activistsList);
  }, [activistsList]);

  // 🔗 useEffect للبحث المتقدم في الصحفيين الآخرين (ربط صحفي بصحفي)
  useEffect(() => {
    if (journalistPeerSearchTerm.trim() === '') {
      setFilteredJournalistPeers(journalistsList);
    } else {
      const filtered = journalistsList.filter(j =>
        j.full_name.toLowerCase().includes(journalistPeerSearchTerm.toLowerCase())
      );
      setFilteredJournalistPeers(filtered);
    }
  }, [journalistPeerSearchTerm, journalistsList]);

  useEffect(() => {
    setFilteredJournalistPeers(journalistsList);
  }, [journalistsList]);

  // 🔗 تحميل الصحفيين المرتبطين مسبقاً في وضع التعديل
  useEffect(() => {
    if (mode === 'edit' && journalistData && journalistsList.length > 0) {
      setTimeout(() => {
        if (journalistData.linked_journalists) {
          try {
            const linkedIds = Array.isArray(journalistData.linked_journalists)
              ? journalistData.linked_journalists
              : JSON.parse(journalistData.linked_journalists || '[]');

            const linkedPeers = linkedIds
              .map(id => journalistsList.find(j => j.id == id))
              .filter(Boolean)
              .filter(j => j.id != journalistData.id)
              .map(j => ({ ...j, isNew: false }));

            setSelectedJournalistPeers(linkedPeers);
          } catch (e) {
            console.error("فشل في تحميل الصحفيين المرتبطين:", e);
          }
        }
      }, 500);
    }
  }, [mode, journalistData, journalistsList]);

  // 🆕 تحديث الاختيارات في وضع التعديل
  useEffect(() => {
    if (mode === 'edit' && journalistData && institutionsList.length > 0 && activistsList.length > 0) {
      setTimeout(() => {
        // تحديث المؤسسة المختارة
        if (journalistData.linked_institution) {
          const linkedInst = institutionsList.find(inst => inst.id == journalistData.linked_institution);
          if (linkedInst) {
            console.log('🔄 تحميل المؤسسة المختارة:', linkedInst);
            setSelectedInstitutions([{ ...linkedInst, isNew: false }]);
          }
        }
        
        // تحديث الناشطين المختارين
        if (journalistData.linked_activists) {
          try {
            const linkedActivistIds = Array.isArray(journalistData.linked_activists)
              ? journalistData.linked_activists
              : JSON.parse(journalistData.linked_activists || '[]');
            
            const linkedActivists = linkedActivistIds
              .map(id => activistsList.find(act => act.id == id))
              .filter(Boolean)
              .map(act => ({ ...act, isNew: false }));
            
            console.log('🔄 تحميل الناشطين المختارين:', linkedActivists);
            setSelectedActivists(linkedActivists);
          } catch (e) {
            console.error("فشل في تحميل الناشطين المختارين:", e);
          }
        }
      }, 500);
    }
  }, [mode, journalistData, institutionsList, activistsList]);

  const toggleTab = (tab) => activeTab !== tab && setActiveTab(tab);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // إذا تم تغيير الدولة، قم بإعادة تعيين المحافظة
    if (name === 'country' && value !== 'فلسطين') {
      setFormValues(prev => ({
        ...prev,
        [name]: value,
        country_province: '' // إعادة تعيين المحافظة
      }));
    } else {
      setFormValues(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleAddToArray = (key, valueSetter, value) => {
    if (value.trim()) {
      setFormValues(prev => ({ ...prev, [key]: [...(prev[key] || []), value.trim()] }));
      valueSetter('');
    }
  };
  const handleRemoveFromArray = (key, index) => {
    setFormValues(prev => ({
      ...prev,
      [key]: prev[key].filter((_, i) => i !== index)
    }));
  };

  const handleProfileImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) setProfileImage(file);
  };

  const handleAddChild = () => {
    if (!newChild.name.trim()) return;
    setChildren(prev => [...prev, { ...newChild, id: Date.now() }]);
    setNewChild({ name: '', gender: '', birth_date: '' });
  };
  const handleRemoveChild = (id) => setChildren(prev => prev.filter(c => c.id !== id));

  // 🆕 دوال التصريحات المحدثة مع Modal والمحرر الغني
  const handleOpenStatementModal = () => {
    setEditingStatement(null);
    setNewStatement({ title: '', content: '' });
    setShowStatementModal(true);
  };

  const handleEditStatement = (stmt) => {
    setEditingStatement(stmt);
    setNewStatement({ title: stmt.title, content: stmt.content });
    setShowStatementModal(true);
  };

  const handleSaveStatement = () => {
    if (!newStatement.title.trim() || !newStatement.content.trim()) return;
    
    if (editingStatement) {
      // تحديث تصريح موجود
      setStatements(prev => prev.map(stmt => 
        stmt.id === editingStatement.id 
          ? { ...stmt, title: newStatement.title.trim(), content: newStatement.content.trim() }
          : stmt
      ));
    } else {
      // إضافة تصريح جديد
      setStatements(prev => [
        ...prev,
        {
          id: Date.now(),
          title: newStatement.title.trim(),
          content: newStatement.content.trim(),
          date: new Date().toISOString().split('T')[0],
          order: prev.length + 1
        }
      ]);
    }
    
    setNewStatement({ title: '', content: '' });
    setEditingStatement(null);
    setShowStatementModal(false);
  };

  const handleDeleteStatement = (id) => {
    setStatements(prev => prev.filter(stmt => stmt.id !== id));
  };

  const handleCancelStatementModal = () => {
    setNewStatement({ title: '', content: '' });
    setEditingStatement(null);
    setShowStatementModal(false);
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files || []);
    const valid = files.filter(f => f.size <= 5 * 1024 * 1024);
    setImages(prev => [...prev, ...valid]);
  };

  // 🆕 رفع ملفات الفيديو مع تتبع التقدم - يبدأ الرفع فوراً
  const handleVideoUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    const valid = files.filter(f => f.size <= 1024 * 1024 * 1024); // 1GB max
    
    for (const file of valid) {
      const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      // إضافة الملف مع معرف مؤقت
      setVideoFiles(prev => [...prev, { tempId, file, name: file.name, size: file.size, status: 'uploading' }]);
      setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 0, status: 'uploading' } }));
      
      // بدء الرفع
      const fd = new FormData();
      fd.append('video', file);
      
      try {
        const res = await api.post('/upload-video', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setVideoUploading(prev => ({ ...prev, [tempId]: { progress: percent, status: 'uploading' } }));
          }
        });
        
        // نجح الرفع - استبدال الملف المؤقت بالاسم النهائي
        const uploadedName = res.data.name;
        setVideoFiles(prev => prev.map(v => 
          v.tempId === tempId ? uploadedName : v
        ));
        setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 100, status: 'done' } }));
      } catch (err) {
        console.error('فشل رفع الفيديو:', err);
        setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 0, status: 'error', message: err.response?.data?.message || 'فشل رفع الفيديو' } }));
        // إزالة الملف الفاشل من القائمة
        setVideoFiles(prev => prev.filter(v => v.tempId !== tempId));
      }
    }
    
    // تنظيف حقل الإدخال
    if (videoInputRef.current) videoInputRef.current.value = null;
  };

  const uploadFile = async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    try {
      const res = await api.post('/upload-file', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return res.data.name;
    } catch (err) {
      console.error('فشل رفع الملف:', err);
      return null;
    }
  };

  // 🆕 تحقق من اكتمال رفع جميع الفيديوهات
  const areAllVideosUploaded = () => {
    return videoFiles.every(v => typeof v === 'string');
  };

  // 🆕 الحصول على أسماء الفيديوهات المرفوعة فقط
  const getUploadedVideoNames = () => {
    return videoFiles.filter(v => typeof v === 'string');
  };

  const getSocialMediaIcon = (url) => {
    const link = (url || '').toLowerCase();
    if (link.includes('facebook.com') || link.includes('fb.com'))
      return { icon: 'fab fa-facebook', color: 'text-primary', name: 'فيسبوك' };
    if (link.includes('twitter.com') || link.includes('t.co'))
      return { icon: 'fab fa-twitter', color: 'text-info', name: 'تويتر' };
    if (link.includes('instagram.com'))
      return { icon: 'fab fa-instagram', color: 'text-danger', name: 'إنستغرام' };
    if (link.includes('linkedin.com'))
      return { icon: 'fab fa-linkedin', color: 'text-primary', name: 'لينكد إن' };
    if (link.includes('youtube.com') || link.includes('youtu.be'))
      return { icon: 'fab fa-youtube', color: 'text-danger', name: 'يوتيوب' };
    if (link.includes('tiktok.com'))
      return { icon: 'fab fa-tiktok', color: 'text-dark', name: 'تيك توك' };
    if (link.includes('snapchat.com'))
      return { icon: 'fab fa-snapchat', color: 'text-warning', name: 'سناب شات' };
    if (link.includes('telegram.org') || link.includes('t.me'))
      return { icon: 'fab fa-telegram', color: 'text-info', name: 'تيليجرام' };
    if (link.includes('whatsapp.com') || link.includes('wa.me'))
      return { icon: 'fab fa-whatsapp', color: 'text-success', name: 'واتساب' };
    return { icon: 'fas fa-link', color: 'text-secondary', name: 'رابط' };
  };

  // 🆕 دوال التعامل مع المؤسسات الجديدة
  const handleAddNewInstitution = () => {
    console.log('🔍 تم استدعاء handleAddNewInstitution');
    console.log('🔍 اسم المؤسسة الجديدة:', newInstitutionName);
    
    if (newInstitutionName.trim()) {
      const tempId = `new_${Date.now()}`;
      console.log('🔍 المعرف المؤقت:', tempId);
      
      const newInstitution = { id: tempId, title: newInstitutionName.trim() };
      console.log('🔍 المؤسسة الجديدة:', newInstitution);
      
      setNewInstitutions(prev => {
        const updated = [...prev, newInstitution];
        console.log('🔍 قائمة المؤسسات الجديدة المحدثة:', updated);
        return updated;
      });
      
      setSelectedInstitutions(prev => {
        const updated = [...prev, { id: tempId, title: newInstitutionName.trim(), isNew: true }];
        console.log('🔍 قائمة المؤسسات المحددة المحدثة:', updated);
        return updated;
      });
      
      setNewInstitutionName('');
      console.log('✅ تم إضافة المؤسسة الجديدة بنجاح');
    } else {
      console.log('❌ اسم المؤسسة فارغ');
    }
  };

  const handleSelectInstitution = (institutionId) => {
    const institution = institutionsList.find(inst => inst.id == institutionId);
    if (institution && !selectedInstitutions.find(sel => sel.id == institutionId)) {
      setSelectedInstitutions(prev => [...prev, { ...institution, isNew: false }]);
    }
  };

  const handleRemoveInstitution = (institutionId) => {
    setSelectedInstitutions(prev => prev.filter(inst => inst.id !== institutionId));
    // إذا كانت مؤسسة جديدة، احذفها من قائمة الجديدة أيضاً
    setNewInstitutions(prev => prev.filter(inst => inst.id !== institutionId));
  };

  // 🆕 دوال التعامل مع الناشطين الجدد
  const handleAddNewActivist = () => {
    if (newActivistName.trim()) {
      const tempId = `new_${Date.now()}`;
      setNewActivists(prev => [...prev, { id: tempId, full_name: newActivistName.trim() }]);
      setSelectedActivists(prev => [...prev, { id: tempId, full_name: newActivistName.trim(), isNew: true }]);
      setNewActivistName('');
    }
  };

  const handleSelectActivist = (activistId) => {
    const activist = activistsList.find(act => act.id == activistId);
    if (activist && !selectedActivists.find(sel => sel.id == activistId)) {
      setSelectedActivists(prev => [...prev, { ...activist, isNew: false }]);
    }
  };

  const handleRemoveActivist = (activistId) => {
    setSelectedActivists(prev => prev.filter(act => act.id !== activistId));
    // إذا كان ناشط جديد، احذفه من قائمة الجديدة أيضاً
    setNewActivists(prev => prev.filter(act => act.id !== activistId));
  };

  // 🔗 دوال التعامل مع ربط صحفي بصحفي آخر (اختيار من الموجودين فقط)
  const handleSelectJournalistPeer = (journalistId) => {
    const peer = journalistsList.find(j => j.id == journalistId);
    if (peer && !selectedJournalistPeers.find(sel => sel.id == journalistId)) {
      setSelectedJournalistPeers(prev => [...prev, { ...peer, isNew: false }]);
    }
  };

  const handleRemoveJournalistPeer = (journalistId) => {
    setSelectedJournalistPeers(prev => prev.filter(j => j.id !== journalistId));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // فحص التكرار قبل الحفظ
    const matches = await checkBeforeSave(formValues.full_name);
    if (matches && matches.length > 0) {
      setShowDuplicateConfirm(true);
      return;
    }
    doActualSubmit();
  };

  const doActualSubmit = async () => {
    setIsSubmitting(true);
    try {
      console.log('🔍 بدء عملية الحفظ...');
      console.log('📋 المؤسسات الجديدة:', newInstitutions);
      console.log('📋 المؤسسات المحددة:', selectedInstitutions);
      console.log('📋 الناشطين الجدد:', newActivists);
      console.log('📋 الناشطين المحددين:', selectedActivists);

      // 🆕 إنشاء المؤسسات الجديدة أولاً
      const createdInstitutions = [];
      if (newInstitutions.length > 0) {
        console.log('🏢 بدء إنشاء المؤسسات الجديدة...');
        console.log('🏢 عدد المؤسسات الجديدة:', newInstitutions.length);
        console.log('🏢 قائمة المؤسسات الجديدة:', newInstitutions);
        
        for (const newInst of newInstitutions) {
          try {
            console.log('🏢 إنشاء مؤسسة:', newInst.title);
            const response = await api.post('/institutions', {
              title: newInst.title,
              description: `مؤسسة تم إنشاؤها تلقائياً من خلال إضافة صحفي`,
              // 🔧 لا نرسل responsible_type نهائياً لتجنب إنشاء مسؤول تلقائي
              license_status: 'مرخص',
              orientation: 'محايد',
              country: 'فلسطين',
              country_province: '',
              city_or_area: '',
              address_details: '',
            });
            console.log('✅ تم إنشاء المؤسسة بنجاح:', response.data);
            const institutionId = response.data?.id || response.data?.data?.id;
            if (institutionId) {
              createdInstitutions.push({ oldId: newInst.id, newId: institutionId });
            } else {
              console.error('❌ لم يتم العثور على معرف المؤسسة في الاستجابة:', response.data);
            }
          } catch (err) {
            console.error('❌ فشل في إنشاء المؤسسة:', newInst.title, err);
            console.error('❌ تفاصيل الخطأ:', err.response?.data || err);
          }
        }
      } else {
        console.log('🏢 لا توجد مؤسسات جديدة لإنشائها');
      }

      // 🆕 إنشاء الناشطين الجدد ثانياً
      const createdActivists = [];
      if (newActivists.length > 0) {
        console.log('👥 بدء إنشاء الناشطين الجدد...');
        
        for (const newAct of newActivists) {
          try {
            console.log('👤 إنشاء ناشط:', newAct.full_name);
            const response = await api.post('/activists', {
              full_name: newAct.full_name,
              bio: `ناشط تم إنشاؤه تلقائياً من خلال إضافة صحفي`,
              gender: 'ذكر',
              country: 'فلسطين',
              country_province: '',
              city_or_area: '',
              address_details: '',
              specialization: '',
              university_name: '',
              last_work_place: '',
              work_sector: JSON.stringify([]),
              political_orientation: [],
              // ❌ لا نربط الناشط بمؤسسات الصحفي - يجب أن يبقى مستقل
              linked_institution: '',
              linked_journalists: '[]', // سيتم تحديثه لاحقاً بمعرف الصحفي الجديد
            });
            console.log('✅ تم إنشاء الناشط بنجاح:', response.data);
            const activistId = response.data?.id || response.data?.data?.id;
            if (activistId) {
              createdActivists.push({ oldId: newAct.id, newId: activistId });
            } else {
              console.error('❌ لم يتم العثور على معرف الناشط في الاستجابة:', response.data);
            }
          } catch (err) {
            console.error('❌ فشل في إنشاء الناشط:', newAct.full_name, err);
          }
        }
      }

      let uploadedProfileImage = formValues.profile_image || '';
      if (profileImage && typeof profileImage !== 'string') {
        uploadedProfileImage = await uploadFile(profileImage);
      }
      const uploadedImages = await Promise.all(
        images.map(f => (typeof f === 'string' ? f : uploadFile(f)))
      );
      const uploadedAttachments = await Promise.all(
        (formValues.attachments || []).map(f => (typeof f === 'string' ? f : uploadFile(f)))
      );
      // 🆕 الفيديوهات (تم رفعها مسبقاً - نأخذ الأسماء المرفوعة فقط)
      if (!areAllVideosUploaded()) {
        alert('يرجى انتظار اكتمال رفع جميع ملفات الفيديو');
        setIsSubmitting(false);
        return;
      }
      const uploadedVideoFiles = getUploadedVideoNames();
      
      // 🆕 تحديث المعرفات للمؤسسات والناشطين المنشأة حديثاً
      const finalSelectedInstitutions = selectedInstitutions.map(inst => {
        if (inst.isNew) {
          const created = createdInstitutions.find(c => c.oldId === inst.id);
          return created && created.newId ? String(created.newId) : null;
        }
        return inst.id ? String(inst.id) : null;
      }).filter(Boolean);

      const finalSelectedActivists = selectedActivists.map(act => {
        if (act.isNew) {
          const created = createdActivists.find(c => c.oldId === act.id);
          return created && created.newId ? String(created.newId) : null;
        }
        return act.id ? String(act.id) : null;
      }).filter(Boolean);

      // 🔗 الصحفيون الآخرون المرتبطون (اختيار من الموجودين فقط، لا يوجد "جديد")
      const finalSelectedJournalistPeers = selectedJournalistPeers
        .map(j => j.id ? String(j.id) : null)
        .filter(Boolean);

      console.log('🔗 المؤسسات المحددة النهائية:', finalSelectedInstitutions);
      console.log('🔗 الناشطين المحددين النهائيين:', finalSelectedActivists);
      console.log('🔗 الصحفيين الآخرين المحددين:', finalSelectedJournalistPeers);
      console.log('🔍 createdInstitutions:', createdInstitutions);
      console.log('🔍 createdActivists:', createdActivists);

      const dataToSend = {
        full_name: formValues.full_name || '',
        profile_image: uploadedProfileImage || '',
        bio: formValues.bio || '',
        gender: formValues.gender || '',
        id_number: formValues.id_number || '',
        birth_date: formValues.birth_date || '',
        marital_status: formValues.marital_status || '',
        children_names: formValues.children_names || '',
        children_details: JSON.stringify(children),
        political_orientation: formValues.political_orientation || [],
        country_province: formValues.country_province || '',
        city_or_area: formValues.city_or_area || '',
        address_details: formValues.address_details || '',
        map_address: formValues.map_address || '',
        specialization: formValues.specialization || '',
        university_name: formValues.university_name || '',
        last_work_place: formValues.last_work_place || '',
        work_sector: JSON.stringify(formValues.work_sector || []),
        // 🔗 كل المؤسسات في حقل واحد (ما في مؤسسة "أساسية" منفصلة)
        linked_institution: JSON.stringify(finalSelectedInstitutions),
        linked_activists: JSON.stringify(finalSelectedActivists),
        linked_journalists: JSON.stringify(finalSelectedJournalistPeers),
        whatsapp1: formValues.whatsapp1_number
          ? `${formValues.whatsapp1_code}${formValues.whatsapp1_number}`
          : '',
        phone_fax: formValues.phone_fax || '',
        mobile1: formValues.mobile1 || '',
        oreedo_number: formValues.oreedo_number || '',
        email: formValues.email || '',
        website: formValues.website || '',
        social_accounts: JSON.stringify(formValues.social_accounts || []),
        statements: JSON.stringify(statements),
        videos: JSON.stringify(formValues.videos || []),
        images: JSON.stringify(uploadedImages.filter(Boolean)),
        attachments: JSON.stringify(uploadedAttachments.filter(Boolean)),
        video_files: JSON.stringify(uploadedVideoFiles.filter(Boolean)), // 🆕 ملفات فيديو
      };

      console.log('📤 البيانات المرسلة للـ API:');
      console.log('   - linked_institution (البيانات الخام):', finalSelectedInstitutions);
      console.log('   - linked_institution (JSON):', dataToSend.linked_institution);
      console.log('   - linked_activists:', dataToSend.linked_activists);

      let journalistResponse;
      if (mode === 'edit') {
        journalistResponse = await api.put(`/journalists/${journalistData.id}`, dataToSend);
      } else {
        journalistResponse = await api.post('/journalists', dataToSend);
      }

      // ✅ التحقق من طلب الموافقة (data_entry)
      if (journalistResponse.data?.pending) {
        setFormErrors({});
        alert('تم إرسال طلبك للمراجعة من قبل المسؤول. سيتم إشعارك عند اتخاذ القرار.');
        navigate('/dashboard/my-requests');
        return;
      }

      // 🔗 تحديث الناشطين الجدد ليكونوا مرتبطين بالصحفي المنشأ حديثاً
      if (mode === 'create' && createdActivists.length > 0 && journalistResponse.data) {
        const newJournalistId = journalistResponse.data?.id || journalistResponse.data?.data?.id;
        if (newJournalistId) {
          console.log('🔄 تحديث الناشطين الجدد للربط مع الصحفي:', newJournalistId);
          
          for (const createdAct of createdActivists) {
            try {
              // جلب بيانات الناشط الحالية
              const activistResponse = await api.get(`/activists/${createdAct.newId}`);
              const currentActivist = activistResponse.data?.data || activistResponse.data;
              
              // تحديث قائمة الصحفيين المرتبطين
              const currentLinkedJournalists = currentActivist.linked_journalists 
                ? JSON.parse(currentActivist.linked_journalists) 
                : [];
              
              if (!currentLinkedJournalists.includes(String(newJournalistId))) {
                currentLinkedJournalists.push(String(newJournalistId));
                
                // تحديث الناشط
                await api.put(`/activists/${createdAct.newId}`, {
                  ...currentActivist,
                  linked_journalists: JSON.stringify(currentLinkedJournalists)
                });
                
                console.log(`✅ تم ربط الناشط ${createdAct.newId} بالصحفي ${newJournalistId}`);
              }
            } catch (error) {
              console.error(`❌ فشل في ربط الناشط ${createdAct.newId}:`, error);
            }
          }
        }

        // 🔄 ربط الناشطين الموجودين (ليس الجدد) بالصحفي الجديد 
        const existingActivistIds = selectedActivists
          .filter(act => !act.isNew) // فقط الناشطين الموجودين
          .map(act => String(act.id));
        
        if (existingActivistIds.length > 0 && newJournalistId) {
          console.log('🔄 تحديث الناشطين الموجودين للربط مع الصحفي:', newJournalistId);
          
          for (const activistId of existingActivistIds) {
            try {
              // جلب بيانات الناشط الحالية
              const activistResponse = await api.get(`/activists/${activistId}`);
              const currentActivist = activistResponse.data?.data || activistResponse.data;
              
              // تحديث قائمة الصحفيين المرتبطين
              const currentLinkedJournalists = currentActivist.linked_journalists 
                ? JSON.parse(currentActivist.linked_journalists) 
                : [];
              
              if (!currentLinkedJournalists.includes(String(newJournalistId))) {
                currentLinkedJournalists.push(String(newJournalistId));
                
                // تحديث الناشط
                await api.put(`/activists/${activistId}`, {
                  ...currentActivist,
                  linked_journalists: JSON.stringify(currentLinkedJournalists)
                });
                
                console.log(`✅ تم ربط الناشط الموجود ${activistId} بالصحفي ${newJournalistId}`);
              }
            } catch (error) {
              console.error(`❌ فشل في ربط الناشط الموجود ${activistId}:`, error);
            }
          }
        }
      }

      // 🔗 مزامنة ثنائية الاتجاه لربط صحفي بصحفي آخر (تعمل بحالتي الإنشاء والتعديل معاً)
      const currentJournalistId = mode === 'edit'
        ? journalistData.id
        : (journalistResponse.data?.id || journalistResponse.data?.data?.id);

      if (currentJournalistId && finalSelectedJournalistPeers.length > 0) {
        for (const peerId of finalSelectedJournalistPeers) {
          try {
            const peerResponse = await api.get(`/journalists/${peerId}`);
            const peerData = peerResponse.data?.data || peerResponse.data;

            const peerLinkedJournalists = peerData.linked_journalists
              ? JSON.parse(peerData.linked_journalists)
              : [];

            if (!peerLinkedJournalists.includes(String(currentJournalistId))) {
              peerLinkedJournalists.push(String(currentJournalistId));

              // ملاحظة: نرسل full_name (حقل إلزامي) + الحقل المطلوب تحديثه فقط،
              // بدون بقية الحقول (بعضها مصفوفات مُحوَّلة مسبقاً ولا يجب إرسالها مجدداً)
              await api.put(`/journalists/${peerId}`, {
                full_name: peerData.full_name,
                linked_journalists: JSON.stringify(peerLinkedJournalists)
              });

              console.log(`✅ تم ربط الصحفي ${peerId} بالصحفي ${currentJournalistId}`);
            }
          } catch (error) {
            console.error(`❌ فشل في ربط الصحفي ${peerId}:`, error);
          }
        }
      }

      setFormErrors({});
      alert(mode === 'edit' ? 'تم التحديث بنجاح' : 'تمت الإضافة بنجاح');
      navigate('/dashboard/journalists');
    } catch (err) {
      if (err.response?.status === 422) {
        setFormErrors(err.response.data.errors || {});
        alert('يرجى تصحيح الحقول');
      } else {
        console.error(err);
        alert('فشل الحفظ');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePolitical = (item) => {
    setFormValues(prev => {
      const exists = prev.political_orientation.includes(item);
      return {
        ...prev,
        political_orientation: exists
          ? prev.political_orientation.filter(v => v !== item)
          : [...prev.political_orientation, item]
      };
    });
  };

  const toggleWorkSector = (item) => {
    setFormValues(prev => {
      const exists = prev.work_sector.includes(item);
      return {
        ...prev,
        work_sector: exists
          ? prev.work_sector.filter(v => v !== item)
          : [...prev.work_sector, item]
      };
    });
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">{mode === 'edit' ? 'تحديث صحفي' : 'إضافة صحفي جديد'}</CardTitle>
          <Nav tabs className="nav-tabs-custom">
            <NavItem><NavLink className={classnames({ active: activeTab === '1' })} onClick={() => toggleTab('1')}>معلومات شخصية أساسية</NavLink></NavItem>
            <NavItem><NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggleTab('2')}>العنوان والموقع</NavLink></NavItem>
            <NavItem><NavLink className={classnames({ active: activeTab === '3' })} onClick={() => toggleTab('3')}>معلومات الاختصاص والعمل</NavLink></NavItem>
            <NavItem><NavLink className={classnames({ active: activeTab === '4' })} onClick={() => toggleTab('4')}>معلومات الاتصال والتواصل</NavLink></NavItem>
            <NavItem><NavLink className={classnames({ active: activeTab === '5' })} onClick={() => toggleTab('5')}>مرفقات</NavLink></NavItem>
          </Nav>

          <Form className="mt-4" onSubmit={handleSubmit}>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                {/* ✅ المعلومات الأساسية في صف واحد */}
                <div className="mb-5">
                  <div className="mb-3 pb-2 border-bottom">
                    <h5 className="text-primary fw-bold mb-0">
                      <i className="fas fa-user me-2"></i>
                      المعلومات الأساسية
                    </h5>
                  </div>
                  <Row className="g-4"> 
                    {/* الاسم الكامل */}
                    <Col md={3}>
                      <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
                        <Label className="form-label fw-bold mb-3 text-dark d-block">
                          الاسم الكامل <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="full_name"
                          value={formValues.full_name}
                          onChange={(e) => { handleChange(e); handleNameChange(e.target.value); }}
                          onBlur={handleNameBlur}
                          className={`form-control-lg border-2 ${formErrors.full_name ? 'is-invalid border-danger' : 'border-primary'}`}
                          placeholder="أدخل الاسم الكامل"
                          required
                        />
                        {formErrors.full_name && (
                          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.full_name[0]}</div>
                        )}
                        <DuplicateWarning matches={duplicateWarning} checking={checkingDuplicate} error={duplicateError} onDismiss={dismissWarning} />
                      </div>
                    </Col>
{/* الجنس */}
<Col md={2}>
  <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
    <Label className="form-label fw-bold mb-3 text-dark d-block">الجنس</Label>
    <div className="d-flex gap-3 mt-2">
      {['ذكر', 'أنثى'].map(gender => (
        <div
          key={gender}
          className="form-check"
          onClick={() => setFormValues(prev => ({ ...prev, gender }))}
        >
          <input
            className="form-check-input fs-5"
            type="radio"
            name="gender"
            id={`gender_${gender}`}
            value={gender}
            checked={formValues.gender === gender}
            onChange={() => setFormValues(prev => ({ ...prev, gender }))}
          />
          <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor={`gender_${gender}`}>
            {gender}
          </label>
        </div>
      ))}
    </div>
  </div>
</Col>

      {/* رقم الهوية */}
      <Col md={2}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رقم الهوية</Label>
          <Input
            name="id_number"
            value={formValues.id_number}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.id_number ? 'is-invalid border-danger' : 'border-primary'}`}
            placeholder="123456789"
          />
          {formErrors.id_number && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.id_number[0]}</div>
          )}
        </div>
      </Col>

      {/* تاريخ الميلاد */}
      <Col md={2}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">تاريخ الميلاد</Label>
          <Input
            type="date"
            name="birth_date"
            value={formValues.birth_date}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.birth_date ? 'is-invalid border-danger' : 'border-primary'}`}
          />
          {formErrors.birth_date && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.birth_date[0]}</div>
          )}
        </div>
      </Col>

      {/* الحالة الاجتماعية */}
      <Col md={3}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">الحالة الاجتماعية</Label>
          <div className="d-flex gap-2 flex-wrap">
            {['متزوج', 'أعزب', 'مطلق', 'غير محدد'].map(status => (
              <div
                key={status}
                className="form-check mb-2"
                onClick={() => setFormValues(prev => ({ ...prev, marital_status: status }))}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="marital_status"
                  id={`marital_status_${status}`}
                  value={status}
                  checked={formValues.marital_status === status}
                  onChange={() => setFormValues(prev => ({ ...prev, marital_status: status }))}
                />
                <label className="form-check-label fw-semibold text-dark ms-2" htmlFor={`marital_status_${status}`}>
                  {status}
                </label>
              </div>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  </div>

  {/* ✅ تفاصيل السيرة الذاتية */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-success fw-bold mb-0">
        <i className="fas fa-file-alt me-2"></i>
        السيرة الذاتية
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      {/* مكان السيرة الذاتية: */}
      <div className="editor-container" style={{ minHeight: '350px', width: '100%' }}>
    <Editor
  apiKey="s63csl3mxs9qcpfxz7ti9a4mx3zjto2mof448ll6atc7kxvi"
  value={formValues.bio}
  init={{
    height: 350,
    width: '100%',
    menubar: 'file edit view insert format tools table help',
    directionality: 'rtl',
    // language: 'ar', // ✅ شلت هاي لأنها بتخفي الأدوات
    plugins: [
      'advlist','autolink','lists','link','image','charmap','preview',
      'anchor','searchreplace','visualblocks','code','fullscreen',
      'insertdatetime','media','table','help','wordcount'
    ],
    toolbar: 'undo redo | styles | fontfamily fontsize | forecolor backcolor | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link image media | removeformat | code fullscreen',
    
    // ✅ إضافات ضرورية
    style_formats_merge: true,
    formats: {
      alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
      aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
      alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
      alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' }
    },
    
    // ✅ استخدم font_formats (مش font_family_formats)
    font_formats: 
      'Arial=arial,helvetica,sans-serif;' +
      'Times New Roman=times new roman,times,serif;' +
      'Courier New=courier new,courier,monospace;' +
      'Tahoma=tahoma,arial,helvetica,sans-serif;' +
      'Verdana=verdana,arial,helvetica,sans-serif;' +
      'Georgia=georgia,serif;' +
      'Comic Sans MS=comic sans ms,cursive',
    
    // ✅ استخدم fontsize_formats (هاد صحيح)
    fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt',
    
    toolbar_mode: 'wrap',
    branding: false,
    resize: true,
    statusbar: true,
   content_style: `
  body { 
    font-family: Tahoma, Arial, sans-serif; 
    font-size: 16px; 
    direction: rtl; 
  }
  
  /* ✅ أنماط المحاذاة */
  .left { text-align: left !important; }
  .center { text-align: center !important; }
  .right { text-align: right !important; }
  .full { text-align: justify !important; }
  
  /* ✅ دعم RTL */
  p, h1, h2, h3, h4, h5, h6, div, ul, ol, li, table, td, th {
    direction: rtl;
  }
`,
    
    setup: function (editor) {
      editor.on('init', function () {
        console.log('TinyMCE تم تحميله بنجاح!');
        
        // ✅ تأكد من ظهور الأدوات
        setTimeout(() => {
          const fontSelect = editor.getContainer().querySelector('.tox-tbtn[aria-label*="Font"]');
          const sizeSelect = editor.getContainer().querySelector('.tox-tbtn[aria-label*="Size"], .tox-tbtn[aria-label*="حجم"]');
          
          if (!fontSelect) console.warn('مشكلة في fontselect');
          if (!sizeSelect) console.warn('مشكلة في fontsizeselect');
        }, 1000);
      });
    }
  }}
  onEditorChange={val => setFormValues({ ...formValues, bio: val })}
/>
      </div>
    </div>
  </div>

  {/* ✅ جدول الأبناء */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-info fw-bold mb-0">
        <i className="fas fa-baby me-2"></i>
        معلومات العائلة
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      
      {/* إضافة ابن جديد */}
      <div className="p-4 border-2 border-dashed border-info rounded-3 mb-4 bg-light">
        <h6 className="text-info fw-bold mb-3">
          <i className="fas fa-plus me-2"></i>
          إضافة ابن/ابنة جديد
        </h6>
        <Row className="g-3 align-items-end">
          <Col md={4}>
            <Label className="form-label fw-semibold mb-2 text-dark">اسم الابن/البنت</Label>
            <Input
              placeholder="أدخل الاسم الكامل"
              value={newChild.name}
              onChange={(e) => setNewChild({...newChild, name: e.target.value})}
              className="form-control-lg border-2 border-info"
            />
          </Col>
          <Col md={3}>
            <Label className="form-label fw-semibold mb-2 text-dark">الجنس</Label>
            <Input
              type="select"
              value={newChild.gender}
              onChange={(e) => setNewChild({...newChild, gender: e.target.value})}
              className="form-control-lg border-2 border-info"
            >
              <option value="">-- اختر الجنس --</option>
              <option value="ذكر">ذكر</option>
              <option value="أنثى">أنثى</option>
            </Input>
          </Col>
          <Col md={3}>
            <Label className="form-label fw-semibold mb-2 text-dark">تاريخ الميلاد</Label>
            <Input
              type="date"
              value={newChild.birth_date}
              onChange={(e) => setNewChild({...newChild, birth_date: e.target.value})}
              className="form-control-lg border-2 border-info"
            />
          </Col>
          <Col md={2}>
            <Button 
              color="info" 
              onClick={handleAddChild} 
              disabled={!newChild.name.trim()}
              className="w-100 fw-bold"
              size="lg"
            >
              <i className="fas fa-plus me-1"></i>
              إضافة
            </Button>
          </Col>
        </Row>
      </div>

      {/* جدول الأبناء */}
      {children.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover table-striped align-middle border-2">
            <thead className="table-info">
              <tr>
                <th className="fw-bold fs-6 py-3">#</th>
                <th className="fw-bold fs-6 py-3">الاسم الكامل</th>
                <th className="fw-bold fs-6 py-3">الجنس</th>
                <th className="fw-bold fs-6 py-3">تاريخ الميلاد</th>
                <th className="fw-bold fs-6 py-3 text-center">العمليات</th>
              </tr>
            </thead>
            <tbody>
              {children.map((child, index) => (
                <tr key={child.id || index} className="align-middle">
                  <td className="fw-medium text-muted py-3">{index + 1}</td>
                  <td className="fw-semibold text-dark py-3">{child.name}</td>
                  <td className="py-3">
                    <span className={`badge ${child.gender === 'ذكر' ? 'bg-primary' : 'bg-danger'} rounded-pill`}>
                      {child.gender}
                    </span>
                  </td>
                  <td className="text-muted py-3">{child.birth_date}</td>
                  <td className="text-center py-3">
                    <Button
                      color="outline-danger"
                      size="sm"
                      onClick={() => handleRemoveChild(child.id)}
                      className="fw-semibold px-3"
                    >
                      <i className="fas fa-trash me-1"></i>
                      حذف
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-5 text-muted">
          <i className="fas fa-baby fa-3x mb-3 opacity-50"></i>
          <p className="fs-5">لا توجد بيانات أبناء مضافة</p>
        </div>
      )}
    </div>
  </div>

  {/* ✅ الميول السياسية */}
<div className="mb-5">
  <div className="mb-3 pb-2 border-bottom">
    <h5 className="text-warning fw-bold mb-0">
      <i className="fas fa-vote-yea me-2"></i>
      التوجهات السياسية
    </h5>
  </div>
  <div className="p-4 border rounded-3 shadow-sm bg-white">
    <div className="d-flex justify-content-between align-items-center mb-4">
      <p className="text-muted mb-0">اختر الميول السياسية المناسبة (يمكن اختيار أكثر من خيار)</p>
      {formValues.political_orientation?.length > 0 && (
        <Button
          color="outline-danger"
          size="sm"
          onClick={() => setFormValues(prev => ({ ...prev, political_orientation: [] }))}
          className="fw-medium"
        >
          <i className="fas fa-times me-1"></i>
          إزالة كل التحديد
        </Button>
      )}
    </div>
    
    <div className="d-flex flex-wrap gap-3">
      {[
        "جبهة تحرير", "جبهة ديمقراطية", "جبهة شعبية", "جبهة عربية",
        "جبهة نضال", "جهاد اسلامي", "حركة حماس", "حركة فتح",
        "حزب شعب", "حزب فدا", "غير محدد", "مبادرة وطنية",
        "مستقل", "معارض", "يسار"
      ].map(item => {
        const isSelected = formValues.political_orientation?.includes(item);
        return (
          <button
            key={item}
            type="button"
            onClick={() => {
              const exists = formValues.political_orientation?.includes(item);
              setFormValues(prev => ({
                ...prev,
                political_orientation: exists
                  ? prev.political_orientation.filter(v => v !== item)
                  : [...(prev.political_orientation || []), item]
              }));
            }}
            className={`btn ${isSelected 
              ? 'btn-warning text-dark fw-bold' 
              : 'btn-outline-dark text-dark bg-light border-2'
            } fw-medium px-3 py-2 rounded-pill`}
            style={{ 
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              transform: isSelected ? 'scale(1.05)' : 'scale(1)',
              fontSize: '0.95rem',
              minHeight: '40px'
            }}
          >
            {isSelected && <i className="fas fa-check me-1"></i>}
            {item}
          </button>
        );
      })}
    </div>
    
    {formValues.political_orientation?.length > 0 && (
      <div className="mt-4 p-3 bg-light rounded">
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-info fw-bold">
            <i className="fas fa-info-circle me-1"></i>
            تم اختيار {formValues.political_orientation.length} عنصر: 
            <span className="text-dark ms-1">
              {formValues.political_orientation.join(' - ')}
            </span>
          </small>
        </div>
      </div>
    )}
  </div>
</div>

  {/* ✅ الصورة الشخصية */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-secondary fw-bold mb-0">
        <i className="fas fa-camera me-2"></i>
        الصورة الشخصية
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      <Row className="g-4 align-items-center">
        <Col md={6}>
          <div className="border-2 border-dashed border-secondary rounded-3 p-4 text-center">
            <Input
              type="file"
              accept="image/*"
              onChange={handleProfileImageUpload}
              className={`form-control-lg border-0 ${formErrors.profile_image ? 'is-invalid' : ''}`}
              innerRef={profileImageRef}
            />
            <div className="mt-2 text-muted">
              <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
              <p className="mb-0">اختر صورة شخصية</p>
              <small>PNG, JPG, JPEG حتى 2MB</small>
            </div>
            {formErrors.profile_image && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.profile_image[0]}</div>
            )}
          </div>
        </Col>
        
        {(profileImage || formValues.profile_image) && (
          <Col md={6}>
            <div className="text-center">
              <div className="position-relative d-inline-block">
                <img
src={profileImage ? URL.createObjectURL(profileImage) : `${FILE_BASE_URL}/uploads/images/${formValues.profile_image}`}
                  alt="صورة شخصية"
                  className="img-fluid rounded-circle border border-3 border-light shadow-lg"
                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                />
                <div className="position-absolute top-0 end-0">
                  <Button
                    color="danger"
                    size="sm"
                    onClick={() => {
                      setProfileImage(null);
                      setFormValues(prev => ({...prev, profile_image: ''}));
                      if (profileImageRef.current) profileImageRef.current.value = null;
                    }}
                    className="rounded-circle fw-semibold"
                    style={{ width: '35px', height: '35px' }}
                  >
                    <i className="fas fa-times"></i>
                  </Button>
                </div>
              </div>
              <p className="mt-3 text-success fw-medium">
                <i className="fas fa-check-circle me-1"></i>
                تم رفع الصورة بنجاح
              </p>
            </div>
          </Col>
        )}
      </Row>
    </div>
  </div>
</TabPane>


            <TabPane tabId="2">
  {/* ✅ معلومات العنوان والموقع */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-map-marker-alt me-2"></i>
        معلومات العنوان والموقع
      </h5>
    </div>
    
    {/* الصف الأول - الدولة والمحافظة والمدينة في صف واحد */}
    <Row className="g-4 mb-4">
      {/* الدولة */}
      <Col md={4}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            الدولة <span className="text-danger">*</span>
          </Label>
          <Input
            type="select"
            name="country"
            value={formValues.country}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.country ? 'is-invalid border-danger' : 'border-primary'}`}
          >
            <option value="فلسطين">فلسطين</option>
            <option value="الأردن">الأردن</option>
            <option value="لبنان">لبنان</option>
            <option value="سوريا">سوريا</option>
            <option value="مصر">مصر</option>
            <option value="السعودية">السعودية</option>
            <option value="الإمارات">الإمارات</option>
            <option value="قطر">قطر</option>
            <option value="الكويت">الكويت</option>
            <option value="العراق">العراق</option>
            <option value="المغرب">المغرب</option>
            <option value="الجزائر">الجزائر</option>
            <option value="تونس">تونس</option>
            <option value="ليبيا">ليبيا</option>
            <option value="السودان">السودان</option>
            <option value="اليمن">اليمن</option>
            <option value="عمان">عمان</option>
            <option value="البحرين">البحرين</option>
            <option value="أخرى">أخرى</option>
          </Input>
          {formErrors.country && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.country[0]}</div>
          )}
        </div>
      </Col>

      {/* المحافظة - يظهر فقط إذا كانت الدولة فلسطين */}
      {formValues.country === 'فلسطين' && (
        <Col md={4}>
          <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              المحافظة <span className="text-danger">*</span>
            </Label>
            <Input
              type="select"
              name="country_province"
              value={formValues.country_province}
              onChange={handleChange}
              className={`form-control-lg border-2 ${formErrors.country_province ? 'is-invalid border-danger' : 'border-primary'}`}
            >
              <option value="">-- اختر المحافظة --</option>
              {[
                "اريحا", "الخليل", "القدس", "بيت لحم", "جنين",
                "رام الله", "سلفيت", "طوباس", "طولكرم", "غزة", "قلقيلية", "نابلس"
              ].map((province) => (
                <option key={province} value={province}>{province}</option>
              ))}
            </Input>
            {formErrors.country_province && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.country_province[0]}</div>
            )}
          </div>
        </Col>
      )}

      {/* المدينة / القرية / المخيم */}
      <Col md={formValues.country === 'فلسطين' ? 4 : 8}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            {formValues.country === 'فلسطين' ? 'المدينة / القرية / المخيم' : 'المدينة / المنطقة'} <span className="text-danger">*</span>
          </Label>
          <Input
            name="city_or_area"
            value={formValues.city_or_area}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.city_or_area ? 'is-invalid border-danger' : 'border-primary'}`}
            placeholder={formValues.country === 'فلسطين' ? 'أدخل اسم المدينة أو القرية أو المخيم' : 'أدخل اسم المدينة أو المنطقة'}
          />
          {formErrors.city_or_area && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.city_or_area[0]}</div>
          )}
        </div>
      </Col>
    </Row>

    {/* الصف الثاني - تفاصيل العنوان */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-home me-2 text-success"></i>
          تفاصيل إضافية للعنوان
        </Label>
        <Input
          type="textarea"
          rows="3"
          name="address_details"
          value={formValues.address_details}
          onChange={handleChange}
          className={`form-control-lg border-2 ${formErrors.address_details ? 'is-invalid border-danger' : 'border-success'}`}
          placeholder="أدخل تفاصيل العنوان مثل: رقم البناية، اسم الشارع، معالم قريبة..."
        />
        {formErrors.address_details && (
          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.address_details[0]}</div>
        )}
      </div>
    </div>

    {/* الموقع الجغرافي */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-globe me-2 text-info"></i>
          الموقع الجغرافي على الخريطة
        </Label>
        
        <Row className="g-3 mb-3">
          <Col md={8}>
            <Input
              name="map_address"
              value={formValues.map_address}
              readOnly
              className={`form-control-lg border-2 ${formErrors.map_address ? 'is-invalid border-danger' : 'border-info'} bg-light`}
              placeholder="سيتم تحديد الموقع تلقائياً عند النقر على الخريطة"
            />
            {formErrors.map_address && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.map_address[0]}</div>
            )}
          </Col>
          <Col md={4}>
            <Button 
              color="info" 
              className="w-100 fw-bold"
              size="lg"
              onClick={() => {
                // يمكن إضافة وظيفة لإعادة تعيين الموقع
                setFormValues(prev => ({...prev, map_address: ''}));
              }}
            >
              <i className="fas fa-map-marked-alt me-1"></i>
              إعادة تحديد الموقع
            </Button>
          </Col>
        </Row>

        {/* الخريطة */}
        <div className="position-relative">
          <div 
            id="map" 
            className="border border-2 border-info rounded-3 shadow-sm"
            style={{ height: "400px", width: "100%" }}
          ></div>
          
          {/* معلومات مساعدة */}
          <div className="mt-3 p-3 bg-light rounded border">
            <div className="d-flex align-items-center text-muted">
              <i className="fas fa-info-circle me-2 text-info"></i>
              <small className="fw-medium">
                انقر على الخريطة لتحديد موقعك بدقة. يمكنك سحب العلامة لتعديل الموقع.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</TabPane>

            <TabPane tabId="3">
  {/* ✅ معلومات التعليم والعمل */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-success fw-bold mb-0">
        <i className="fas fa-graduation-cap me-2"></i>
        معلومات التعليم والعمل
      </h5>
    </div>
    
    {/* الصف الأول - التخصص والجامعة */}
    <Row className="g-4 mb-4"> 
      {/* التخصص */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-book me-2 text-success"></i>
            التخصص
          </Label>
          <Input
            name="specialization"
            value={formValues.specialization}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.specialization ? 'is-invalid border-danger' : 'border-success'}`}
            placeholder="أدخل التخصص الدراسي"
          />
          {formErrors.specialization && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.specialization[0]}</div>
          )}
        </div>
      </Col>

      {/* اسم الجامعة */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-university me-2 text-success"></i>
            اسم الجامعة
          </Label>
          <Input
            name="university_name"
            value={formValues.university_name}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.university_name ? 'is-invalid border-danger' : 'border-success'}`}
            placeholder="أدخل اسم الجامعة"
          />
          {formErrors.university_name && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.university_name[0]}</div>
          )}
        </div>
      </Col>
    </Row>

    {/* الصف الثاني - معلومات العمل */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-briefcase me-2 text-primary"></i>
          مكان العمل الأخير
        </Label>
        <Input
          name="last_work_place"
          value={formValues.last_work_place}
          onChange={handleChange}
          className={`form-control-lg border-2 ${formErrors.last_work_place ? 'is-invalid border-danger' : 'border-primary'}`}
          placeholder="أدخل اسم الشركة أو المؤسسة"
        />
        {formErrors.last_work_place && (
          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.last_work_place[0]}</div>
        )}
      </div>
    </div>

    {/* قطاع العمل */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-industry me-2 text-warning"></i>
          قطاع العمل
        </Label>
        <p className="text-muted mb-3">اختر قطاع العمل المناسب (يمكن اختيار أكثر من خيار)</p>
        
        <div className="d-flex flex-wrap gap-3">
          {[
            "حكومي مدني", "حكومي عسكري", "قطاع خاص", "مؤسسة غير حكومية",
            "جمعية غير ربحية", "عامل بالخارج", "عامل بالداخل", "بلا عمل"
          ].map(item => {
            const isSelected = formValues.work_sector?.includes(item);
            return (
              <button
                key={item}
                type="button"
                onClick={() => {
                  const exists = formValues.work_sector?.includes(item);
                  setFormValues(prev => ({
                    ...prev,
                    work_sector: exists
                      ? prev.work_sector.filter(v => v !== item)
                      : [...(prev.work_sector || []), item]
                  }));
                }}
                className={`btn ${isSelected 
                  ? 'btn-warning text-dark fw-bold' 
                  : 'btn-outline-dark text-dark bg-light border-2'
                } fw-medium px-3 py-2 rounded-pill`}
                style={{ 
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                  fontSize: '0.9rem'
                }}
              >
                {isSelected && <i className="fas fa-check me-1"></i>}
                {item}
              </button>
            );
          })}
        </div>
        
        {formValues.work_sector?.length > 0 && (
          <div className="mt-3 p-3 bg-light rounded">
            <small className="text-warning fw-bold">
              <i className="fas fa-info-circle me-1"></i>
              تم اختيار {formValues.work_sector.length} قطاع: 
              <span className="text-dark ms-1">
                {formValues.work_sector.join(' - ')}
              </span>
            </small>
          </div>
        )}
        
        {formErrors.work_sector && (
          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.work_sector[0]}</div>
        )}
      </div>
    </div>

    {/* الروابط المؤسسية */}
    <Row className="g-4">
      {/* الربط مع مؤسسة */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-building me-2 text-info"></i>
            الربط مع مؤسسات
          </Label>
          
          {/* اختيار من المؤسسات الموجودة */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-search me-1 text-info"></i>
              ابحث عن مؤسسة:
            </label>
            <Input
              type="text"
              placeholder="ابحث عن مؤسسة (اكتب اسم أو جزء منه)..."
              className="form-control border-2 border-info mb-2"
              value={institutionSearchTerm}
              onChange={(e) => setInstitutionSearchTerm(e.target.value)}
            />
            <small className="text-muted">اكتب للبحث السريع في أسماء المؤسسات</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
            <Input
              type="select"
              onChange={(e) => {
                if (e.target.value) {
                  handleSelectInstitution(e.target.value);
                  e.target.value = '';
                }
              }}
              className="form-control border-2 border-info"
              size="5"
            >
              <option value="">-- اختر مؤسسة --</option>
              {Array.isArray(filteredInstitutions) && filteredInstitutions
                .filter(inst => !selectedInstitutions.find(sel => sel.id == inst.id))
                .map(inst => (
                  <option key={inst.id} value={inst.id}>{inst.title}</option>
                ))}
            </Input>
            {institutionSearchTerm && filteredInstitutions.length === 0 && (
              <small className="text-warning d-block mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                لا توجد نتائج للبحث "{institutionSearchTerm}"
              </small>
            )}
            {institutionSearchTerm && filteredInstitutions.length > 0 && (
              <small className="text-success d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                تم العثور على {filteredInstitutions.length} مؤسسة
              </small>
            )}
          </div>

          {/* إضافة مؤسسة جديدة */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-plus-circle me-1 text-success"></i>
              إضافة مؤسسة جديدة:
            </label>
            <InputGroup>
              <Input
                type="text"
                placeholder="اسم المؤسسة الجديدة"
                value={newInstitutionName}
                onChange={(e) => setNewInstitutionName(e.target.value)}
                className="form-control border-2 border-success"
                onKeyPress={(e) => e.key === 'Enter' && handleAddNewInstitution()}
              />
              <Button
                color="success"
                onClick={handleAddNewInstitution}
                disabled={!newInstitutionName.trim()}
              >
                <i className="fas fa-plus"></i>
              </Button>
            </InputGroup>
          </div>

          {/* المؤسسات المختارة */}
          {selectedInstitutions.length > 0 && (
            <div>
              <label className="form-label fw-semibold text-dark mb-2">المؤسسات المختارة:</label>
              <div className="d-flex flex-wrap gap-2">
                {selectedInstitutions.map(inst => (
                  <Badge
                    key={inst.id}
                    color={inst.isNew ? "success" : "info"}
                    className="d-flex align-items-center gap-2 p-2 fs-6"
                  >
                    <i className={`fas ${inst.isNew ? 'fa-plus' : 'fa-building'} me-1`}></i>
                    {inst.title}
                    <Button
                      color="transparent"
                      size="sm"
                      className="p-0 text-white border-0"
                      onClick={() => handleRemoveInstitution(inst.id)}
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </Badge>
                ))}
              </div>
              {selectedInstitutions.some(inst => inst.isNew) && (
                <small className="text-success d-block mt-2">
                  <i className="fas fa-info-circle me-1"></i>
                  المؤسسات الجديدة سيتم إنشاؤها تلقائياً عند الحفظ
                </small>
              )}
            </div>
          )}

          {formErrors.linked_institution && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.linked_institution[0]}</div>
          )}
        </div>
      </Col>

      {/* الربط مع ناشطين */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-users me-2 text-secondary"></i>
            الربط مع ناشطين
          </Label>
          
          {/* اختيار من الناشطين الموجودين */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-search me-1 text-secondary"></i>
              ابحث عن ناشط:
            </label>
            <Input
              type="text"
              placeholder="ابحث عن ناشط (اكتب اسم أو جزء منه)..."
              className="form-control border-2 border-secondary mb-2"
              value={activistSearchTerm}
              onChange={(e) => setActivistSearchTerm(e.target.value)}
            />
            <small className="text-muted">اكتب للبحث السريع في أسماء الناشطين</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
            <Input
              type="select"
              onChange={(e) => {
                if (e.target.value) {
                  handleSelectActivist(e.target.value);
                  e.target.value = '';
                }
              }}
              className="form-control border-2 border-secondary"
              size="5"
            >
              <option value="">-- اختر ناشط --</option>
              {filteredActivistsList?.filter(act => !selectedActivists.find(sel => sel.id == act.id))
                .map(act => (
                  <option key={act.id} value={act.id}>{act.full_name}</option>
                ))}
            </Input>
            {activistSearchTerm && filteredActivistsList.length === 0 && (
              <small className="text-warning d-block mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                لا توجد نتائج للبحث "{activistSearchTerm}"
              </small>
            )}
            {activistSearchTerm && filteredActivistsList.length > 0 && (
              <small className="text-success d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                تم العثور على {filteredActivistsList.length} ناشط
              </small>
            )}
          </div>

          {/* إضافة ناشط جديد */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-plus-circle me-1 text-warning"></i>
              إضافة ناشط جديد:
            </label>
            <InputGroup>
              <Input
                type="text"
                placeholder="اسم الناشط الجديد"
                value={newActivistName}
                onChange={(e) => setNewActivistName(e.target.value)}
                className="form-control border-2 border-warning"
                onKeyPress={(e) => e.key === 'Enter' && handleAddNewActivist()}
              />
              <Button
                color="warning"
                onClick={handleAddNewActivist}
                disabled={!newActivistName.trim()}
              >
                <i className="fas fa-plus"></i>
              </Button>
            </InputGroup>
          </div>

          {/* الناشطين المختارين */}
          {selectedActivists.length > 0 && (
            <div>
              <label className="form-label fw-semibold text-dark mb-2">الناشطين المختارين:</label>
              <div className="d-flex flex-wrap gap-2">
                {selectedActivists.map(act => (
                  <Badge
                    key={act.id}
                    color={act.isNew ? "warning" : "secondary"}
                    className="d-flex align-items-center gap-2 p-2 fs-6"
                  >
                    <i className={`fas ${act.isNew ? 'fa-plus' : 'fa-user'} me-1`}></i>
                    {act.full_name}
                    <Button
                      color="transparent"
                      size="sm"
                      className="p-0 text-white border-0"
                      onClick={() => handleRemoveActivist(act.id)}
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </Badge>
                ))}
              </div>
              {selectedActivists.some(act => act.isNew) && (
                <small className="text-warning d-block mt-2">
                  <i className="fas fa-info-circle me-1"></i>
                  الناشطين الجدد سيتم إنشاؤهم تلقائياً عند الحفظ
                </small>
              )}
            </div>
          )}

          {formErrors.linked_activists && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.linked_activists[0]}</div>
          )}
        </div>
      </Col>
    </Row>

    {/* 🔗 الربط مع صحفيين آخرين */}
    <Row className="g-4 mt-1">
      <Col md={12}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-user-friends me-2 text-primary"></i>
            الربط مع صحفيين آخرين
          </Label>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-search me-1 text-primary"></i>
              ابحث عن صحفي:
            </label>
            <Input
              type="text"
              placeholder="ابحث عن صحفي (اكتب اسم أو جزء منه)..."
              className="form-control border-2 border-primary mb-2"
              value={journalistPeerSearchTerm}
              onChange={(e) => setJournalistPeerSearchTerm(e.target.value)}
            />
            <small className="text-muted">اكتب للبحث السريع في أسماء الصحفيين</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
            <Input
              type="select"
              onChange={(e) => {
                if (e.target.value) {
                  handleSelectJournalistPeer(e.target.value);
                  e.target.value = '';
                }
              }}
              className="form-control border-2 border-primary"
              size="5"
            >
              <option value="">-- اختر صحفي --</option>
              {Array.isArray(filteredJournalistPeers) && filteredJournalistPeers
                .filter(j => !journalistData || j.id != journalistData.id)
                .filter(j => !selectedJournalistPeers.find(sel => sel.id == j.id))
                .map(j => (
                  <option key={j.id} value={j.id}>{j.full_name}</option>
                ))}
            </Input>
            {journalistPeerSearchTerm && filteredJournalistPeers.length === 0 && (
              <small className="text-warning d-block mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                لا توجد نتائج للبحث "{journalistPeerSearchTerm}"
              </small>
            )}
            {journalistPeerSearchTerm && filteredJournalistPeers.length > 0 && (
              <small className="text-success d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                تم العثور على {filteredJournalistPeers.length} صحفي
              </small>
            )}
          </div>

          {selectedJournalistPeers.length > 0 && (
            <div>
              <label className="form-label fw-semibold text-dark mb-2">الصحفيون المختارون:</label>
              <div className="d-flex flex-wrap gap-2">
                {selectedJournalistPeers.map(j => (
                  <Badge
                    key={j.id}
                    color="primary"
                    className="d-flex align-items-center gap-2 p-2 fs-6"
                  >
                    <i className="fas fa-user me-1"></i>
                    {j.full_name}
                    <Button
                      color="transparent"
                      size="sm"
                      className="p-0 text-white border-0"
                      onClick={() => handleRemoveJournalistPeer(j.id)}
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </Badge>
                ))}
              </div>
            </div>
          )}

          {formErrors.linked_journalists && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.linked_journalists[0]}</div>
          )}
        </div>
      </Col>
    </Row>
  </div>
</TabPane>

<TabPane tabId="4">
  {/* ✅ وسائل التواصل */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-phone me-2"></i>
        وسائل التواصل والاتصال
      </h5>
    </div>
    
    {/* أرقام الواتساب */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-success">
        <h6 className="text-success fw-bold mb-0">
          <i className="fab fa-whatsapp me-2"></i>
          أرقام الواتساب
        </h6>
      </div>
      <Row className="g-4">
        {/* واتساب 1 */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              واتساب 1 <span className="text-danger">*</span>
            </Label>
            <InputGroup className="input-group-lg">
              <Input
                type="text"
                name="whatsapp1_number"
                placeholder="رقم الجوال"
                value={formValues.whatsapp1_number || ''}
                onChange={handleChange}
                className={`border-2 ${formErrors.whatsapp1 ? 'is-invalid border-danger' : 'border-success'}`}
              />
              <select
                name="whatsapp1_code"
                value={formValues.whatsapp1_code || '+970'}
                onChange={handleChange}
                className={`form-select border-2 ${formErrors.whatsapp1 ? 'is-invalid border-danger' : 'border-success'}`}
                style={{ maxWidth: '100px' }}
              >
                <option value="+970">+970</option>
                <option value="+972">+972</option>
              </select>
            </InputGroup>
            {formErrors.whatsapp1 && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.whatsapp1[0]}</div>
            )}
          </div>
        </Col>

       {/* تلفون/فاكس */}
<Col md={6}>
  <div className="p-4 border rounded-3 shadow-sm bg-white">
    <Label className="form-label fw-bold mb-3 text-dark d-block">تلفون/فاكس</Label>
    <Input
      name="phone_fax"
      value={formValues.phone_fax}
      onChange={handleChange}
      placeholder="رقم التلفون أو الفاكس"
      className={`form-control-lg border-2 ${formErrors.phone_fax ? 'is-invalid border-danger' : 'border-success'}`}
    />
    {formErrors.phone_fax && (
      <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.phone_fax[0]}</div>
    )}
  </div>
</Col>
      </Row>
    </div>

    {/* أرقام الجوال */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-info">
        <h6 className="text-info fw-bold mb-0">
          <i className="fas fa-mobile-alt me-2"></i>
          أرقام الجوال
        </h6>
      </div>
      <Row className="g-4">
        {/* جوال 1 */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">رقم جوال</Label>
            <Input
              name="mobile1"
              value={formValues.mobile1}
              onChange={handleChange}
              placeholder="أدخل رقم الجوال "
              className={`form-control-lg border-2 ${formErrors.mobile1 ? 'is-invalid border-danger' : 'border-info'}`}
            />
            {formErrors.mobile1 && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.mobile1[0]}</div>
            )}
          </div>
        </Col>

      {/* أوريدو */}
<Col md={6}>
  <div className="p-4 border rounded-3 shadow-sm bg-white">
    <Label className="form-label fw-bold mb-3 text-dark d-block">رقم أوريدو</Label>
    <Input
      name="oreedo_number"
      value={formValues.oreedo_number}
      onChange={handleChange}
      placeholder="رقم أوريدو"
      className={`form-control-lg border-2 ${formErrors.oreedo_number ? 'is-invalid border-danger' : 'border-info'}`}
    />
    {formErrors.oreedo_number && (
      <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.oreedo_number[0]}</div>
    )}
  </div>
</Col>
      </Row>
    </div>

    {/* البريد الإلكتروني والموقع */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-warning">
        <h6 className="text-warning fw-bold mb-0">
          <i className="fas fa-globe me-2"></i>
          الاتصال الإلكتروني
        </h6>
      </div>
      <Row className="g-4">
        {/* البريد الإلكتروني */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-envelope me-2 text-warning"></i>
              البريد الإلكتروني
            </Label>
            <Input
              type="email"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              placeholder="example@domain.com"
              className={`form-control-lg border-2 ${formErrors.email ? 'is-invalid border-danger' : 'border-warning'}`}
            />
            {formErrors.email && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.email[0]}</div>
            )}
          </div>
        </Col>

        {/* الموقع الإلكتروني */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-link me-2 text-warning"></i>
              الموقع الإلكتروني
            </Label>
            <Input
              type="url"
              name="website"
              value={formValues.website}
              onChange={handleChange}
              placeholder="https://www.example.com"
              className={`form-control-lg border-2 ${formErrors.website ? 'is-invalid border-danger' : 'border-warning'}`}
            />
            {formErrors.website && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.website[0]}</div>
            )}
          </div>
        </Col>
      </Row>
    </div>

    {/* حسابات التواصل الاجتماعي */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-secondary">
        <h6 className="text-secondary fw-bold mb-0">
          <i className="fas fa-share-alt me-2"></i>
          حسابات التواصل الاجتماعي
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* إضافة حساب جديد */}
        <div className="mb-4 p-3 border-2 border-dashed border-secondary rounded-3 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">إضافة رابط حساب التواصل</Label>
          <InputGroup className="input-group-lg">
            <Input
              placeholder="https://facebook.com/username أو https://twitter.com/username"
              value={newSocialAccount}
              onChange={(e) => setNewSocialAccount(e.target.value)}
              className="border-2 border-secondary"
            />
            <Button
              color="secondary"
              onClick={() =>
                handleAddToArray('social_accounts', setNewSocialAccount, newSocialAccount)
              }
              className="fw-bold"
            >
              <i className="fas fa-plus me-1"></i>
              إضافة
            </Button>
          </InputGroup>
        </div>

        {/* عرض الحسابات المضافة */}
        {formValues.social_accounts?.length > 0 ? (
  <div>
    <Label className="form-label fw-bold mb-3 text-dark d-block">الحسابات المضافة:</Label>
    <div className="list-group">
      {formValues.social_accounts?.map((link, i) => {
        const socialInfo = getSocialMediaIcon(link);
        return (
          <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <i className={`${socialInfo.icon} fa-lg me-3 ${socialInfo.color}`}></i>
              <div>
                <div className="fw-medium">{link}</div>
                <small className="text-muted">{socialInfo.name}</small>
              </div>
            </div>
            <Button 
              color="outline-danger" 
              size="sm"
              onClick={() => handleRemoveFromArray('social_accounts', i)}
              className="fw-medium"
            >
              <i className="fas fa-trash me-1"></i>
              حذف
            </Button>
          </div>
        );
      })}
    </div>
  </div>
) : (
  <div className="text-center py-4 text-muted">
    <i className="fas fa-share-alt fa-2x mb-3 opacity-50"></i>
    <p>لم يتم إضافة أي حسابات تواصل اجتماعي بعد</p>
  </div>
)}
      </div>
    </div>
  </div>
</TabPane>

            <TabPane tabId="5">
  {/* ✅ المرفقات والوسائط */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-info fw-bold mb-0">
        <i className="fas fa-file-upload me-2"></i>
        المرفقات والوسائط
      </h5>
    </div>

    {/* ✅ الأقوال والتصريحات */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-success">
        <h6 className="text-success fw-bold mb-0">
          <i className="fas fa-quote-left me-2"></i>
          الأقوال والتصريحات
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* زر إضافة تصريح */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h6 className="text-success fw-bold mb-0">
            <i className="fas fa-quote-left me-2"></i>
            قائمة التصريحات
          </h6>
          <Button 
            color="success" 
            onClick={handleOpenStatementModal}
            className="fw-bold"
            size="lg"
          >
            <i className="fas fa-plus me-2"></i>
            إضافة تصريح
          </Button>
        </div>

        {/* عرض التصريحات */}
        {statements.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-hover table-striped align-middle border-2">
              <thead className="table-success">
                <tr>
                  <th className="fw-bold fs-6 py-3" style={{width: '60px'}}>#</th>
                  <th className="fw-bold fs-6 py-3" style={{width: '200px'}}>العنوان</th>
                  <th className="fw-bold fs-6 py-3">التصريح</th>
                  <th className="fw-bold fs-6 py-3 text-center" style={{width: '150px'}}>العمليات</th>
                </tr>
              </thead>
              <tbody>
                {statements.map((statement, index) => (
                  <tr key={statement.id}>
                    <td className="fw-medium text-muted py-3">{index + 1}</td>
                    <td className="fw-semibold text-dark py-3">{statement.title}</td>
                    <td className="py-3" style={{maxWidth: '350px'}}>
                      <div className="text-truncate" title={statement.content}>
                        {statement.content.length > 100 
                          ? statement.content.substring(0, 100) + '...'
                          : statement.content
                        }
                      </div>
                    </td>
                    <td className="text-center py-3">
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          color="outline-warning"
                          size="sm"
                          onClick={() => handleEditStatement(statement)}
                          className="fw-medium"
                        >
                          <i className="fas fa-edit me-1"></i>
                          تحرير
                        </Button>
                        <Button
                          color="outline-danger"
                          size="sm"
                          onClick={() => handleDeleteStatement(statement.id)}
                          className="fw-medium"
                        >
                          <i className="fas fa-trash me-1"></i>
                          حذف
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-5 text-muted">
            <i className="fas fa-quote-left fa-3x mb-3 opacity-50"></i>
            <p className="fs-5">لا توجد تصريحات مضافة</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ روابط يوتيوب */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-danger">
        <h6 className="text-danger fw-bold mb-0">
          <i className="fab fa-youtube me-2"></i>
          روابط يوتيوب
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* إضافة رابط يوتيوب */}
        <div className="p-4 border-2 border-dashed border-danger rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">إضافة رابط يوتيوب</Label>
          <InputGroup className="input-group-lg">
            <Input
              placeholder="https://youtube.com/watch?v=..."
              value={newYoutubeLink}
              onChange={(e) => setNewYoutubeLink(e.target.value)}
              className={`border-2 ${formErrors.videos ? 'is-invalid border-danger' : 'border-danger'}`}
            />
            <Button
              color="danger"
              onClick={() => handleAddToArray('videos', setNewYoutubeLink, newYoutubeLink)}
              className="fw-bold"
            >
              <i className="fab fa-youtube me-1"></i>
              إضافة
            </Button>
          </InputGroup>
          {formErrors.videos && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.videos[0]}</div>
          )}
        </div>

        {/* عرض روابط اليوتيوب */}
        {formValues.videos?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الفيديوهات المضافة:</Label>
            <div className="list-group">
              {formValues.videos.map((link, i) => (
                <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <i className="fab fa-youtube fa-lg me-3 text-danger"></i>
                    <div>
                      <div className="fw-medium text-truncate" style={{maxWidth: '400px'}}>{link}</div>
                      <small className="text-muted">فيديو يوتيوب</small>
                    </div>
                  </div>
                  <Button 
                    color="outline-danger" 
                    size="sm"
                    onClick={() => handleRemoveFromArray('videos', i)}
                    className="fw-medium"
                  >
                    <i className="fas fa-trash me-1"></i>
                    حذف
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fab fa-youtube fa-2x mb-3 opacity-50"></i>
            <p>لم يتم إضافة أي فيديوهات يوتيوب بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* 🆕 ملفات الفيديو */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-purple" style={{borderColor: '#6f42c1'}}>
        <h6 className="fw-bold mb-0" style={{color: '#6f42c1'}}>
          <i className="fas fa-video me-2"></i>
          ملفات الفيديو
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع الفيديو */}
        <div className="p-4 border-2 border-dashed rounded-3 mb-4 bg-light" style={{borderColor: '#6f42c1'}}>
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع ملفات الفيديو</Label>
          <Input
            type="file"
            multiple
            accept="video/mp4,video/webm,video/ogg,video/avi,video/mov,video/wmv,video/mkv,video/flv,video/3gp,video/m4v,.mp4,.webm,.ogg,.avi,.mov,.wmv,.mkv,.flv,.3gp,.m4v"
            onChange={handleVideoUpload}
            className={`form-control-lg border-2 ${formErrors.video_files ? 'is-invalid border-danger' : ''}`}
            style={{borderColor: '#6f42c1'}}
            innerRef={videoInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
            <p className="mb-0">اختر ملفات فيديو متعددة</p>
            <small>MP4, WebM, OGG, AVI, MOV, WMV, MKV, FLV, 3GP, M4V - حتى 1GB لكل ملف</small>
          </div>
          {formErrors.video_files && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.video_files[0]}</div>
          )}
        </div>

        {/* عرض ملفات الفيديو */}
        {videoFiles.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">ملفات الفيديو ({videoFiles.length}):</Label>
            <div className="list-group">
              {videoFiles.map((file, index) => {
                const isUploaded = typeof file === 'string';
                const tempId = !isUploaded ? file.tempId : null;
                const uploadState = tempId ? videoUploading[tempId] : null;
                const fileName = isUploaded ? file : file.name;
                const fileSize = isUploaded ? '' : (file.size / (1024 * 1024)).toFixed(1) + ' MB';
                const isUploading = uploadState?.status === 'uploading';
                const hasError = uploadState?.status === 'error';
                
                return (
                  <div key={tempId || index} className="list-group-item">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center flex-grow-1">
                        {isUploading ? (
                          <div className="spinner-border spinner-border-sm me-3" style={{color: '#6f42c1'}} role="status">
                            <span className="visually-hidden">جاري الرفع...</span>
                          </div>
                        ) : isUploaded ? (
                          <i className="fas fa-check-circle fa-lg me-3 text-success"></i>
                        ) : hasError ? (
                          <i className="fas fa-exclamation-circle fa-lg me-3 text-danger"></i>
                        ) : (
                          <i className="fas fa-video fa-lg me-3" style={{color: '#6f42c1'}}></i>
                        )}
                        <div className="flex-grow-1">
                          <div className="fw-medium text-truncate" style={{maxWidth: '400px'}}>{fileName}</div>
                          <small className="text-muted">
                            {isUploading ? (
                              <span className="text-primary">جاري الرفع... {uploadState?.progress || 0}%</span>
                            ) : isUploaded ? (
                              <span className="text-success">✓ تم الرفع بنجاح</span>
                            ) : hasError ? (
                              <span className="text-danger">{uploadState?.message || 'فشل الرفع'}</span>
                            ) : (
                              `فيديو • ${fileSize}`
                            )}
                          </small>
                        </div>
                      </div>
                      {isUploaded && (
                        <Button
                          color="outline-danger"
                          size="sm"
                          onClick={() => {
                            const updated = [...videoFiles];
                            updated.splice(index, 1);
                            setVideoFiles(updated);
                          }}
                          className="fw-medium"
                        >
                          <i className="fas fa-trash me-1"></i>
                          حذف
                        </Button>
                      )}
                    </div>
                    {/* شريط التقدم */}
                    {isUploading && (
                      <div className="progress mt-2" style={{height: '6px'}}>
                        <div 
                          className="progress-bar" 
                          role="progressbar" 
                          style={{width: `${uploadState?.progress || 0}%`, backgroundColor: '#6f42c1'}}
                          aria-valuenow={uploadState?.progress || 0} 
                          aria-valuemin="0" 
                          aria-valuemax="100"
                        ></div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-video fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي ملفات فيديو بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ الصور */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-warning">
        <h6 className="text-warning fw-bold mb-0">
          <i className="fas fa-images me-2"></i>
          الصور
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع الصور */}
        <div className="p-4 border-2 border-dashed border-warning rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع الصور</Label>
          <Input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            className={`form-control-lg border-2 ${formErrors.images ? 'is-invalid border-danger' : 'border-warning'}`}
            innerRef={imageInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
            <p className="mb-0">اختر صور متعددة</p>
            <small>PNG, JPG, JPEG حتى 5MB لكل صورة</small>
          </div>
          {formErrors.images && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.images[0]}</div>
          )}
        </div>

        {/* عرض الصور */}
        {images.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الصور المرفوعة ({images.length}):</Label>
            <Row className="g-3">
             {images.map((file, index) => {
               const isExisting = typeof file === 'string';
               const imageUrl = isExisting
                 ? `${FILE_BASE_URL}/uploads/images/${file}`
                 : URL.createObjectURL(file);

                return (
                  <Col key={index} md={2} sm={3} xs={4}>
                    <div className="position-relative">
                      <img
                        src={imageUrl}
                        alt={`preview-${index}`}
                        className="img-fluid rounded shadow-sm border border-2 border-warning"
                        style={{ height: "120px", width: "100%", objectFit: "cover" }}
                      />
                      <Button
                        color="danger"
                        onClick={() => {
                          const updated = [...images];
                          updated.splice(index, 1);
                          setImages(updated);
                          if (!isExisting && imageInputRef.current) imageInputRef.current.value = null;
                        }}
                        className="position-absolute top-0 end-0 rounded-circle"
                        style={{
                          width: "30px",
                          height: "30px",
                          padding: "0",
                          fontSize: "12px",
                          transform: "translate(50%, -50%)"
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-images fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي صور بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ مرفقات أخرى */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-secondary">
        <h6 className="text-secondary fw-bold mb-0">
          <i className="fas fa-paperclip me-2"></i>
          مرفقات أخرى
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع المرفقات */}
        <div className="p-4 border-2 border-dashed border-secondary rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع الملفات</Label>
          <Input
            type="file"
            multiple
            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx"
            onChange={(e) => {
              const files = Array.from(e.target.files);
              setFormValues(prev => ({
                ...prev,
                attachments: [...prev.attachments, ...files]
              }));
              if (attachmentInputRef.current) attachmentInputRef.current.value = null;
            }}
            className={`form-control-lg border-2 ${formErrors.attachments ? 'is-invalid border-danger' : 'border-secondary'}`}
            innerRef={attachmentInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-file-upload fa-2x mb-2"></i>
            <p className="mb-0">اختر ملفات متعددة</p>
            <small>PDF, Word, Excel, PowerPoint, TXT حتى 10MB لكل ملف</small>
          </div>
          {formErrors.attachments && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.attachments[0]}</div>
          )}
        </div>

        {/* عرض المرفقات */}
        {formValues.attachments?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الملفات المرفقة ({formValues.attachments.length}):</Label>
            <div className="list-group">
              {formValues.attachments.map((file, index) => {
                const fileName = typeof file === "string" ? file : file.name;
                const fileSize = typeof file === "string" ? "" : (file.size / 1024).toFixed(1) + " KB";
                const fileType = typeof file === "string" ? "" : file.type;
                
                let icon = "fas fa-file";
                let iconColor = "text-secondary";
                let fileTypeName = "ملف";
                
                if (fileType.includes("pdf") || fileName.includes(".pdf")) {
                  icon = "fas fa-file-pdf";
                  iconColor = "text-danger";
                  fileTypeName = "PDF";
                } else if (fileType.includes("excel") || fileName.includes(".xls")) {
                  icon = "fas fa-file-excel";
                  iconColor = "text-success";
                  fileTypeName = "Excel";
                } else if (fileType.includes("word") || fileName.includes(".doc")) {
                  icon = "fas fa-file-word";
                  iconColor = "text-primary";
                  fileTypeName = "Word";
                } else if (fileType.includes("powerpoint") || fileName.includes(".ppt")) {
                  icon = "fas fa-file-powerpoint";
                  iconColor = "text-warning";
                  fileTypeName = "PowerPoint";
                } else if (fileType.includes("text") || fileName.includes(".txt")) {
                  icon = "fas fa-file-alt";
                  iconColor = "text-info";
                  fileTypeName = "نص";
                }

                return (
                  <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <i className={`${icon} fa-lg me-3 ${iconColor}`}></i>
                      <div>
                        <div className="fw-medium text-truncate" style={{maxWidth: '400px'}}>{fileName}</div>
                        <small className="text-muted">{fileTypeName} • {fileSize}</small>
                      </div>
                    </div>
                    <Button
                      color="outline-danger"
                      size="sm"
                      onClick={() =>
                        setFormValues(prev => ({
                          ...prev,
                          attachments: prev.attachments.filter((_, i) => i !== index),
                        }))
                      }
                      className="fw-medium"
                    >
                      <i className="fas fa-trash me-1"></i>
                      حذف
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-paperclip fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي ملفات بعد</p>
          </div>
        )}
      </div>
    </div>
  </div>
</TabPane>
            </TabContent>

            <div className="text-end mt-4">
              <Button color="primary" type="submit" disabled={isSubmitting || !areAllVideosUploaded()}>
                {!areAllVideosUploaded() ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    جاري رفع الفيديوهات...
                  </>
                ) : isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    جاري الحفظ...
                  </>
                ) : (
                  mode === 'edit' ? 'تحديث الصحفي' : 'إضافة الصحفي'
                )}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>

      {/* 🆕 Modal إضافة/تحرير التصريحات */}
      <Modal isOpen={showStatementModal} toggle={handleCancelStatementModal} size="lg">
        <ModalHeader toggle={handleCancelStatementModal}>
          <i className="fas fa-quote-left me-2 text-success"></i>
          {editingStatement ? 'تحرير التصريح' : 'إضافة تصريح جديد'}
        </ModalHeader>
        <ModalBody>
          <Form>
            {/* عنوان التصريح */}
            <div className="mb-4">
              <Label className="form-label fw-bold mb-3 text-dark d-block">
                عنوان التصريح <span className="text-danger">*</span>
              </Label>
              <Input
                placeholder="أدخل عنوان التصريح"
                value={newStatement.title}
                onChange={(e) => setNewStatement({...newStatement, title: e.target.value})}
                className="form-control-lg border-2 border-success"
              />
            </div>

            {/* نص التصريح - محرر غني */}
            <div className="mb-4">
              <Label className="form-label fw-bold mb-3 text-dark d-block">
                نص التصريح <span className="text-danger">*</span>
              </Label>
              <div className="border border-2 border-success rounded">
                <Editor
                  value={newStatement.content}
                  onEditorChange={(content) => setNewStatement({...newStatement, content})}
                  init={{
                    height: 400,
                    menubar: false,
                    plugins: [
                      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                      'insertdatetime', 'media', 'table', 'wordcount', 'paste'
                    ],
                    toolbar: 'undo redo | styles | fontfamily fontsize | forecolor backcolor | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link image media | removeformat | code fullscreen',
                    
                    // ✅ نفس إعدادات محرر السيرة الذاتية
                    style_formats_merge: true,
                    formats: {
                      alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
                      aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
                      alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
                      alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' }
                    },
                    
                    // ✅ خطوط متنوعة
                    font_formats: 
                      'Arial=arial,helvetica,sans-serif;' +
                      'Times New Roman=times new roman,times,serif;' +
                      'Courier New=courier new,courier,monospace;' +
                      'Tahoma=tahoma,arial,helvetica,sans-serif;' +
                      'Verdana=verdana,arial,helvetica,sans-serif;' +
                      'Georgia=georgia,serif;' +
                      'Comic Sans MS=comic sans ms,cursive',
                    
                    // ✅ أحجام خطوط متنوعة
                    fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt',
                    
                    toolbar_mode: 'wrap',
                    branding: false,
                    resize: true,
                    statusbar: true,
content_style: `
  body { 
    font-family: Tahoma, Arial, sans-serif; 
    font-size: 16px; 
    direction: rtl; 
  }
  
  /* ✅ أنماط المحاذاة */
  .left { text-align: left !important; }
  .center { text-align: center !important; }
  .right { text-align: right !important; }
  .full { text-align: justify !important; }
  
  /* ✅ دعم RTL */
  p, h1, h2, h3, h4, h5, h6, div, ul, ol, li, table, td, th {
    direction: rtl;
  }
`,                    
                    // ✅ المحرر بالإنجليزية لإظهار جميع الخيارات
                    language: 'en', // تغيير من 'ar' إلى 'en'
                    directionality: 'rtl', // الاتجاه يبقى من اليمين لليسار للعربية
                    
                    // ✅ دعم نسخ ولصق مع تنسيقات وصور
                    paste_data_images: true,
                    paste_as_text: false,
                    paste_retain_style_properties: 'all',
                    automatic_uploads: true,
                    file_picker_types: 'image',
                    images_upload_handler: function (blobInfo, success, failure) {
                      const reader = new FileReader();
                      reader.onload = function() {
                        success(reader.result);
                      };
                      reader.readAsDataURL(blobInfo.blob());
                    },
                    
                    setup: function (editor) {
                      editor.on('init', function () {
                        console.log('TinyMCE Statements Editor loaded successfully!');
                        
                        // تأكد من ظهور أدوات الخط والحجم
                        setTimeout(() => {
                          const fontSelect = editor.getContainer().querySelector('.tox-tbtn[aria-label*="Font"]');
                          const sizeSelect = editor.getContainer().querySelector('.tox-tbtn[aria-label*="Size"]');
                          
                          if (!fontSelect) console.warn('Font selector issue');
                          if (!sizeSelect) console.warn('Font size selector issue');
                        }, 1000);
                      });
                    }
                  }}
                />
              </div>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button 
            color="success" 
            onClick={handleSaveStatement}
            disabled={!newStatement.title.trim() || !newStatement.content.trim()}
            className="fw-bold px-4"
          >
            <i className="fas fa-save me-2"></i>
            {editingStatement ? 'حفظ التعديلات' : 'إضافة التصريح'}
          </Button>
          <Button 
            color="outline-secondary" 
            onClick={handleCancelStatementModal}
            className="fw-medium px-4"
          >
            <i className="fas fa-times me-2"></i>
            إلغاء
          </Button>
        </ModalFooter>
      </Modal>

      {/* 🆕 بوب أب تأكيد الحفظ عند وجود أسماء مكررة */}
      <DuplicateSaveConfirm
        isOpen={showDuplicateConfirm}
        matches={duplicateWarning}
        onConfirm={() => { setShowDuplicateConfirm(false); doActualSubmit(); }}
        onCancel={() => { setShowDuplicateConfirm(false); setIsSubmitting(false); }}
      />
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CreateJournalist);
